export default {"src":"/_next/static/media/check_green.8a2c796e.svg","height":18,"width":23,"blurWidth":0,"blurHeight":0};